import { Calendar01SolidRounded } from "@hugeicons-pro/core-solid-rounded";
import { useLingui } from "@lingui/react/macro";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { CalendarProvider } from "~/components/event-calendar/calendar-context";
import { PageHead } from "~/components/ui/page-head";

export const Route = createFileRoute("/_app/manager/planning")({
	component: Page,
});

function Page() {
	const { t } = useLingui();

	return (
		<>
			<PageHead
				icon={Calendar01SolidRounded}
				title={t`Global Planning`}
				subtitle={t`Keep your schedule on track with this calendar view of your shows episodes.`}
			/>
			<CalendarProvider>
				<Outlet />
			</CalendarProvider>
		</>
	);
}
